let _0x62073b = "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";Function(window["\x61\x74\x6F\x62"](_0x62073b))();



/* ===== Product card image swiper — page 1 + "Load more" (loop) ===== */
(function () {
  var CARD_SEL = '.jas-product-image > .swiper-container';

  // load every image in this swiper, including loop clones
  function lazyFix(sw) {
    if (!window.lazySizes || !sw || !sw.el) return;
    sw.el.querySelectorAll('.jas-pr-image-link').forEach(function (a) {
      // clone copied while the original was loading → reset so lazysizes picks it up
      if (a.classList.contains('lazyloading') && a.closest('.swiper-slide-duplicate')) {
        a.classList.remove('lazyloading');
        a.classList.add('lazyload');
      }
      if (a.classList.contains('lazyload')) lazySizes.loader.unveil(a);
    });
  }

  function initCard(el) {
    if (!el || el.swiper || el.dataset.swiperInit) return;
    if (el.querySelectorAll('.swiper-slide').length < 2) return;

    // fresh from Load more and not laid out yet → wait
    if (!el.offsetWidth) {
      el._swTries = (el._swTries || 0) + 1;
      if (el._swTries < 60) requestAnimationFrame(function () { initCard(el); });
      return;
    }

    el.dataset.swiperInit = '1';
    // mark images BEFORE init so loop clones inherit it
    el.querySelectorAll('.lazyload').forEach(function (n) { n.classList.add('lazypreload'); });

    new Swiper(el, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 5,
      observer: true,
      observeParents: true,
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      on: {
        init: function () {
          var sw = this;
          // once the visible image loads (card in view), load the rest
          if (sw.el.querySelector('.lazyloaded')) return lazyFix(sw);
          sw.el.addEventListener('lazyloaded', function once() {
            sw.el.removeEventListener('lazyloaded', once);
            lazyFix(sw);
          });
        },
        touchStart: function () { lazyFix(this); },
        slideChangeTransitionStart: function () { lazyFix(this); },
        loopFix: function () { lazyFix(this); }
      }
    });
  }

  function initIn(root) {
    if (root.matches && root.matches(CARD_SEL)) return initCard(root);
    root.querySelectorAll(CARD_SEL).forEach(initCard);
  }

  function refresh(root) {
    (root || document).querySelectorAll(CARD_SEL).forEach(function (el) {
      if (el.swiper) el.swiper.update(); else initCard(el);
    });
  }

  function boot() {
    if (typeof Swiper === 'undefined') return setTimeout(boot, 100);

    var holder = document.querySelector('.jas-products-holder') || document.body;
    initIn(document);

    // cards appended by Load more
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) requestAnimationFrame(function () { initIn(n); });
        });
      });
    }).observe(holder, { childList: true, subtree: true });

    if (window.jQuery) jQuery(holder).on('layoutComplete arrangeComplete', function () { refresh(holder); });
    window.addEventListener('load', function () { refresh(); });
    window.addEventListener('resize', function () { refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();